import { type Theme } from "@mui/material";

import { type MuiThemeComponentOverride } from "./types";

// Augment Typography variants to include custom "page-header" variant
declare module "@mui/material/styles" {
  interface TypographyVariants {
    "page-header": React.CSSProperties;
  }

  interface TypographyVariantsOptions {
    "page-header"?: React.CSSProperties;
  }
}

// Update the Typography component props to allow "page-header" variant
declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    "page-header": true;
  }
}

export function getMuiTypography(_theme: Theme): MuiThemeComponentOverride<"MuiTypography"> {
  return {
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: ["Century Gothic", "CenturyGothic", "AppleGothic", "sans-serif"],
          variants: [
            {
              props: { variant: "page-header" },
              style: {
                // xs breakpoint
                "@media (min-width: 576px)": {
                  // sm breakpoint
                  fontSize: "1.5rem",
                },

                "@media (min-width: 768px)": {
                  // md breakpoint
                  fontSize: "2rem",
                },

                color: "#1380AA",

                fontSize: "1.25rem",
                // Color.BLUE[300].main - primary color
                fontWeight: 500,
              },
            },
          ],
        },
      },
    },
  };
}
